'use client';
import { getColorScheme } from '@/utils/getColorScheme';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';
import { MarkDown } from './atoms/MarkDown';

export default function CustomCode(props) {
    const {
        Anchor,
        Code,
        Tagline,
        Header,
        Body,
        is_edit_mode,
        ColorScheme = 'white',
        VerticalSpacing = '',
    } = props;

    const {
        backgroundColor,
        textColor,
        taglineColor,
        headerColor,
        backgroundStyle,
    } = getColorScheme(ColorScheme, props.GradientDirection);

    let vSpace, containerClass;

    const vspaceKey = String(VerticalSpacing || '').trim();
    const isFullBleed =
        !vspaceKey || vspaceKey === 'default' || vspaceKey === 'full';

    if (vspaceKey === 'larger') {
        vSpace = 'min-h-[900px] lg:min-h-[1200px] xl:min-h-[30vw]';
        containerClass = 'h-full w-full';
    } else if (isFullBleed) {
        vSpace = '';
        containerClass = 'h-full w-full';
    } else {
        vSpace = getVerticalSpacing(vspaceKey);
        containerClass = 'max-w-7xl px-6 lg:px-8';
    }

    return (
        <div
            id={Anchor}
            className={`relative mx-auto w-full ${backgroundColor} ${textColor}`}
            style={backgroundStyle}
        >
            <div
                className={`relative z-[45] mx-auto flex flex-col ${containerClass} ${vSpace}`}
                style={{ minHeight: '100%' }}
            >
                {(Tagline || Header || Body) && (
                    <div className="mx-auto w-full max-w-4xl px-6 pt-10 text-center lg:px-8">
                        {Tagline && (
                            <p
                                className={`font-display text-base font-semibold uppercase leading-7 tracking-wide ${taglineColor} ${
                                    Header || Body ? '' : 'mb-10'
                                }`}
                            >
                                {Tagline}
                            </p>
                        )}
                        {Header && (
                            <MarkDown
                                variant="h2"
                                className={`mt-2 font-display text-3xl tracking-tight lg:text-4xl ${headerColor} ${
                                    Body ? '' : 'mb-10'
                                }`}
                            >
                                {Header}
                            </MarkDown>
                        )}
                        {Body && (
                            <MarkDown
                                className={`mt-6 mb-10 text-base font-text leading-7 md:text-lg ${textColor}`}
                            >
                                {Body}
                            </MarkDown>
                        )}
                    </div>
                )}
                <div className="relative">
                    {/* Editor overlay message */}
                    {is_edit_mode && (
                        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center border-2 border-dashed border-primary-600 bg-white/50">
                            <span className="text-center text-xl text-black">
                                Editor Mode - Enter your custom code in the
                                editor panel.
                            </span>
                        </div>
                    )}

                    {/* Code block - make sure it takes up height */}
                    <div
                        className={`relative ${
                            is_edit_mode ? 'min-h-[300px]' : ''
                        }`}
                        dangerouslySetInnerHTML={{ __html: Code || '' }}
                    />
                </div>
            </div>
        </div>
    );
}
